export default __webpack_public_path__ + "static/P_SearchThumb_MotionDetector-5abfd0c1568ab86aa6a5c48a028a6594.webp";